import * as React from 'react';
import { Button } from 'reactstrap';

export interface IGenericButtonProps {
  id?: string;
  name: string;
  type: "submit" | "button" | "reset";
  variant?: string;
  isOnBackground?: boolean;
  disabled?: boolean;
  iconClassNameLeft?: string;
  iconClassNameRight?: string;
  className?: string;
  clickEvent?: (e?: any) => void;
}

const GenericButton: React.FunctionComponent<IGenericButtonProps> = (props: IGenericButtonProps) => {
  return (
    <Button
      size="lg"
      id={props.id}
      className={props.className}
      type={props.type}
      onClick={props.clickEvent}
      disabled={props.disabled}
      color={props.variant ? props.variant : 'primary'}
    >
      {props.iconClassNameLeft ? <i className={`paddingRight10 ${props.iconClassNameLeft}`} /> : ''}
      {props.name}
      {props.iconClassNameRight ? <i className={`paddingLeft10 ${props.iconClassNameRight}`} /> : ''}
    </Button>
  );
};

export default GenericButton;



// WEBPACK FOOTER //
// ./src/components/shared/genericButton/genericButton.tsx